import API_URL from '../../constants/url'
import fetchNetworkUtil from '../../../../utils/network/fetch'
import { mergeObjectUtil } from 'packages/src'

export async function getApi ({
  endpoint,
  jwt,
  fetchOptions = {}
}) {
  const response = await fetchNetworkUtil(`${API_URL}${endpoint}`, mergeObjectUtil({
    headers: {
      Accept: 'application/json',
      'Content-Type': 'text/plain',
      Authorization: `Bearer ${jwt}`
    },
    method: 'GET'
  }, fetchOptions))
  if (!response.ok) {
    throw (
      await response.json()
    )
  }
  return response.json()
}
